import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { auth, db } from "../firebase";
import { collection, query, where, onSnapshot, doc, writeBatch } from "firebase/firestore";


function Navbar() {
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const lastScrollY = useRef(0);

  const [isCompactMobile, setIsCompactMobile] = useState(
  window.innerWidth < 768 || window.innerHeight < 500
);

const getNavListStyle = (isMobile) => ({
  listStyleType: "none",
  display: "flex",
  flexWrap: "wrap", // ✅ enables wrapping into two rows
  justifyContent: isMobile ? "flex-start" : "center",
  gap: "30px 10px", // vertical and horizontal spacing
  padding: "0",
  margin: "0",
});


   const getButtonStyle = (isMobile) => ({
  backgroundColor: "#007BFF",
  color: "white",
  textDecoration: "none",
  borderRadius: "5px",
  fontWeight: "bold",
  border: "none",
  cursor: "pointer",
  fontSize: isMobile ? "12px" : "16px",
  padding: isMobile ? "6px 10px" : "10px 15px",
  minWidth: isMobile ? "80px" : "10px",
  maxWidth: "150px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  textAlign: "center"
});


useEffect(() => {
  const handleResize = () => {
    setIsCompactMobile(window.innerWidth < 768 || window.innerHeight < 500);
  };
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);


useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);


useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);


  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        const messagesRef = collection(db, "messages");
        const q = query(
          messagesRef,
          where("to", "==", user.uid),
          where("read", "==", false),
          
        );


        const unsubMessages = onSnapshot(q, async (snapshot) => {
  const hasUnread = !snapshot.empty;
  setHasUnreadMessages(hasUnread);

           if (hasUnread) {
            // Mark all unread messages as notified
            const batch = writeBatch(db);
            snapshot.forEach((docSnap) => {
              batch.update(doc(db, "messages", docSnap.id), { notified: true });
            });

          try {
            await batch.commit();
          } catch (error) {
            console.error("Error marking messages as notified:", error);
          }
	  }
        });

        return () => unsubMessages();
      } else {
        setHasUnreadMessages(false);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
  console.log("🔔 Unread Messages?", hasUnreadMessages);
}, [hasUnreadMessages]);



	useEffect(() => {
  const handleScroll = () => {
    const currentY = window.scrollY;

    if (currentY > lastScrollY.current && currentY > 50) {
      setShowNavbar(false); // Scrolling down
    } else {
      setShowNavbar(true); // Scrolling up
    }

    lastScrollY.current = currentY;
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);



  return (
    <nav
  style={{
    ...styles.navbar,
    transform: showNavbar ? "translateY(0)" : "translateY(-100%)",
    transition: "transform 0.3s ease-in-out"
  }}
>

	
{isCompactMobile && (
  <button
    onClick={() => setMenuOpen(!menuOpen)}
    style={{
      background: "none",
      border: "none",
      color: "white",
      fontSize: "24px",
      cursor: "pointer",
      position: "absolute",      // ← Make it absolute
      top: "1px",
      left: "20px",              // ← Anchor it to the left side
      zIndex: 2000               // ← Ensure it's above other elements
    }}
  >
    ☰
  </button>
)}

      <ul
  style={{
       ...getNavListStyle(isCompactMobile),
    display: isCompactMobile
      ? menuOpen
        ? "flex"
        : "none"
      : "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    rowGap: "25px",   // ✅ space between rows when buttons wrap
    columnGap: "10px", // optional horizontal spacing
    padding: "0",
    marginTop: isCompactMobile ? "10px" : "0", // push below hamburger if open
  }}
>
       <li><Link to="/" style={getButtonStyle(isMobile)}>Home</Link></li>
<li><Link to="/login" style={getButtonStyle(isMobile)}>Login</Link></li>
<li><Link to="/post-review" style={getButtonStyle(isMobile)}>Share Your Experience</Link></li>
<li><Link to="/ask" style={getButtonStyle(isMobile)}>Ask an Insider</Link></li>
<li><Link to="/my-network" style={getButtonStyle(isMobile)}>My Network</Link></li>
<li style={{ position: "relative" }}>
  <Link to="/my-account" style={getButtonStyle(isMobile)}>
    My Account
    {hasUnreadMessages && (
      <span style={{
        position: "absolute",
        top: "4px",
        right: "4px",
        height: "10px",
        width: "10px",
        backgroundColor: "yellow",
        borderRadius: "50%"
      }} />
    )}
  </Link>
</li>


      </ul>
    </nav>
  );
}


const styles = {
  navbar: {
    backgroundColor: "#004080",
    padding: "15px",
    display: "flex",
    justifyContent: "center",
    position: "sticky",
    top: "0",
    width: "100%",
    zIndex: "1000"
  },
  navList: {
    listStyleType: "none",
    display: "flex",
    gap: "15px",
    padding: "0",
    margin: "0"
  },
  navButton: {
    backgroundColor: "#007BFF",
    color: "white",
    padding: "10px 15px",
    textDecoration: "none",
    borderRadius: "5px",
    fontSize: "16px",
    fontWeight: "bold",
    transition: "0.3s",
    border: "none",
    minWidth: "160px",     // ✅ ensures even sizing
    cursor: "pointer"
  },
  navButtonHover: {
    backgroundColor: "#0056b3"
  }
};

export default Navbar;
